export default __webpack_public_path__ + "assets/649fb694781181a0835a027d4bbd598f-notecard.png";